module.exports = __webpack_public_path__ + "img/chevronLeft.c50c4a36.svg";